module.exports = __webpack_public_path__ + "images/mobile/loading@2x-92868d69dc0b5038d79837a3638214f8.gif";